<template>
<div class="chapter">
<div class="inner_page">
<p class="h2-label"><a id="page_xiv"></a><a id="page_xv"></a><a id="page_xvi"></a><a id="page_xvii"></a><a id="pt1"></a>PART ONE</p>
<p class="h2a"><em>The Land</em></p>
<p class="poem"><em>The flatter the land oh yes the flatter land but of course</em></p>
<p class="poem"><em>the flatter the land and the sea is as flat as the land</em></p>
<p class="poem"><em>oh yes the flatter the land the more yes the more</em></p>
<p class="poem"><em>it has may have to do with the human mind</em>.</p>
<p class="attribute">GERTRUDE STEIN</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292767317_09_pt1.vue?2fd004f2